export const isActive = ({ value, current }: { value: number; current: number | null }) => {
  return !!(current && value <= current);
};
